import merge from 'deepmerge';

import { type TreatmentCategory } from '@/consts/treatmentCategories';

// TODO: Move URLs here as they are verified as working for multi-brand
const createCommonLegacyUrls = <AppUrl extends string>(appUrl: AppUrl) =>
  ({
    url: appUrl,
  }) as const;

export const createCurologyLegacyUrls = <AppUrl extends string>(
  appUrl: AppUrl,
) =>
  merge(createCommonLegacyUrls(appUrl), {
    auth: {
      guardianConsentRequiredFlow: `${appUrl}/auth/welcome/register`,
      niceToSeeYouAgain: `${appUrl}/auth/nice-to-see-you-again`,
      login: `${appUrl}/auth/login`,
      logout: `${appUrl}/logout`,
      notEligible: `${appUrl}/auth/welcome/availability-notice`,
      register: `${appUrl}/auth/welcome/register`,
      pocketdermBrandTransfer: `${appUrl}/auth/welcome/deleting-old-account`,
    },

    shop: {
      url: `${appUrl}/shop`,
    },

    signup: {
      url: `${appUrl}/signup`,
      smsVerification: <T extends boolean>(
        addCheckoutSuccessfulUrlParam?: T,
      ) => {
        return `${appUrl}/signup/sms-verification${
          addCheckoutSuccessfulUrlParam ? '?checkoutSuccessful=true' : ''
        }` as const;
      },
    },

    dashboard: {
      url: `${appUrl}/dashboard`,
      messageProvider: `${appUrl}/dashboard/message-provider`,
      resubscribe: {
        withCategory: <T extends TreatmentCategory>(treatmentCategory: T) =>
          `${appUrl}/dashboard/resubscribe/${treatmentCategory}` as const,
      },
      shipments: `${appUrl}/dashboard/shipments`,
    },

    patientDashboard: {
      manageSubscription: {
        customize: `${appUrl}/patient-dashboard/manage-subscription/customize`,
      },
    },
  } as const);

export const createAgencyLegacyUrls = <AppUrl extends string>(appUrl: AppUrl) =>
  merge(createCommonLegacyUrls(appUrl), {
    auth: {
      login: `${appUrl}/auth/login`,
      logout: `${appUrl}/logout`,
      notEligible: `${appUrl}/auth/welcome/availability-notice`,
      register: `${appUrl}/auth/welcome/register`,
      eligible: `${appUrl}/auth/welcome`,
      pocketdermBrandTransfer: `${appUrl}/auth/welcome/deleting-old-account`,
    },

    signup: {
      url: `${appUrl}/signup`,
      smsVerification: <T extends boolean>(
        addCheckoutSuccessfulUrlParam?: T,
      ) => {
        return `${appUrl}/signup/sms-verification${
          addCheckoutSuccessfulUrlParam ? '?checkoutSuccessful=true' : ''
        }` as const;
      },
    },

    dashboard: {
      url: `${appUrl}/dashboard`,
      messageProvider: `${appUrl}/dashboard/message-provider`,
      resubscribe: {
        withCategory: <T extends TreatmentCategory>(treatmentCategory: T) =>
          `${appUrl}/dashboard/resubscribe/${treatmentCategory}` as const,
      },
      shipments: `${appUrl}/dashboard/shipments`,
    },
  } as const);
